module.exports = __webpack_public_path__ + "img/france-endocrine-nutritional-metabolic-diseases-male.71112fd0.png";